import type { Dayjs } from 'dayjs';
import React, { type FC, useCallback } from 'react';
import { getIn, useFormikContext } from 'formik';
import { DatePicker, DatePickerProps, DatePickerContext } from '../../DatePicker/DatePicker';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormDatePicker: FC<Partial<DatePickerProps>> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const value = 'value' in props ? props.value : name ? getIn(values, name) : undefined;
  const error = 'error' in props ? props.error : !!context.error;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (value: Dayjs | null, context: DatePickerContext) => {
      if (onChange) {
        onChange(value, context);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue]
  );
  return (
    <DatePicker
      {...props}
      id={(props.id ?? context.name) ? `${context.name}-input` : undefined}
      value={value}
      error={error}
      onChange={handleOnChange}
      dataTest={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
    />
  );
};
